/* eslint-disable */
import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Tab from '../../component/Inc/Tab';
function PopMentorReport(props) {
  const {open, close} = props;
  const tab = [
    {title: '일반 멘토', value: 0},
    {title: '특별 멘토', value: 1}
  ];
  const [tabIdx, setTabIdx] = useState(0);
  return (
    <Modal open={open} close={close} type="pop_mentoring" popSize="s">
      <h2 className="pop_tit">멘토 배정</h2>
      <div className="content_container scroll">
        <div className="com_board_box">
          <div className="board_item">
            <div className="info">
              <span className="tit">교사</span>
              <span className="cont">
                <button className="name btn_link">홍길동103 </button>
              </span>
            </div>
            <div className="info">
              <span className="tit">연락처</span>
              <div className="cont">010-1234-233</div>
            </div>
            <div className="info">
              <span className="tit">담임</span>
              <div className="cont">김담임321</div>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">학생</span>
              <span className="cont">
                <button className="name btn_link">홍학생 </button>
              </span>
            </div>
            <div className="info">
              <span className="tit">연락처</span>
              <div className="cont">010-1234-233</div>
            </div>
            <div className="info">
              <span className="tit">과목</span>
              <div className="cont">국어</div>
            </div>

            <hr className="com_divider" />
            <div className="info">
              <span className="tit">첫 수업 예정일</span>
              <span className="cont">2023, 08, 12 12:30</span>
            </div>
          </div>

          <div className="tab_wrap">
            <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="full" />
          </div>

          <div className="board_item scroll_bar">
            <div className="radio_wrap">
              {[1, 2, 3, 4, 5, 6].map((i, idx) => {
                return (
                  <div key={idx} className="check">
                    <input type="radio" name="radio" id={`radio${idx + 1}`} className="com_chk circle" />
                    <label htmlFor={`radio${idx + 1}`}>홍담임103 (010-1234-1324)</label>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="comment_input">
            <textarea type="text" className="textarea" placeholder="내용입력"></textarea>
          </div>
        </div>
      </div>
      <div className="btn_container">
        <button onClick={close} className="com_btn orange xs">
          확인
        </button>
      </div>
    </Modal>
  );
}

export default PopMentorReport;
